import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './PostDetail.css';
import API_URL from '../config';

const PostDetail = ({ postId, onClose, onEdit }) => {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    fetchPost();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postId]);

  const fetchPost = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/posts/${postId}`);
      setPost(response.data);
      setError(null);
    } catch (err) {
      setError('Error cargando el post');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (window.confirm('¿Estás seguro de que deseas eliminar este post?')) {
      try {
        setIsDeleting(true);
        await axios.delete(`${API_URL}/api/posts/${postId}`);
        onClose();
        if (onEdit) onEdit();
      } catch (err) {
        console.error(err);
        alert('Error al eliminar el post');
      } finally {
        setIsDeleting(false);
      }
    }
  };

  const getCategoryLabel = (category) => {
    const labels = {
      'noticia': 'Noticia',
      'opinión': 'Opinión',
      'review-musical': 'Review Musical',
    };
    return labels[category] || category;
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  if (loading) {
    return (
      <div className="post-detail-overlay" onClick={onClose}>
        <div className="post-detail-modal" onClick={(e) => e.stopPropagation()}>
          <p>Cargando...</p>
        </div>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="post-detail-overlay" onClick={onClose}>
        <div className="post-detail-modal" onClick={(e) => e.stopPropagation()}>
          <p className="error">{error || 'Post no encontrado'}</p>
          <button onClick={onClose} className="close-btn">Cerrar</button>
        </div>
      </div>
    );
  }

  return (
    <div className="post-detail-overlay" onClick={onClose}>
      <div className="post-detail-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-icon" onClick={onClose}>×</button>

        {post.imageUrl && (
          <img src={post.imageUrl} alt={post.title} className="detail-image" />
        )}

        <div className="detail-content">
          <div className="detail-header">
            <span className="category-badge">{getCategoryLabel(post.category)}</span>
            <span className="date">{formatDate(post.createdAt)}</span>
          </div>

          <h1 className="detail-title">{post.title}</h1>

          <p className="detail-description">{post.description}</p>

          <div className="detail-body">{post.content}</div>

          <div className="detail-footer">
            <span className="author">Por {post.author}</span>
            <div className="action-buttons">
              <button 
                className="edit-btn" 
                onClick={() => onEdit && onEdit(post)}
              >
                Editar
              </button>
              <button 
                className="delete-btn" 
                onClick={handleDelete}
                disabled={isDeleting}
              >
                {isDeleting ? 'Eliminando...' : 'Eliminar'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostDetail;